module.exports = __webpack_public_path__ + "854a8bea97c0e62ad6fd12f5efddf19b.woff";